import { render, staticRenderFns } from "./CheckboxGroupInputComponent.vue?vue&type=template&id=9a084604&lang=pug"
import script from "./CheckboxGroupInputComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxGroupInputComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports